import { render, staticRenderFns } from "./list-tasks-draggable.vue?vue&type=template&id=0e33b7fb&scoped=true&"
import script from "./list-tasks-draggable.vue?vue&type=script&lang=js&"
export * from "./list-tasks-draggable.vue?vue&type=script&lang=js&"
import style0 from "./list-tasks-draggable.vue?vue&type=style&index=0&id=0e33b7fb&lang=scss&scoped=true&"
import style1 from "./list-tasks-draggable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e33b7fb",
  null
  
)

export default component.exports